import {FBFieldWithPriceBaseOptions, PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FBFieldBaseOptions, FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {StoreDataType} from "shared/utilities/Store/StoreBase";
import {FBRowOptions} from "FormBuilder/Core/FBRow.Options";
import {FieldFactory} from "FormBuilder/FieldFactory";


export class FBRepeaterOptions extends FBFieldWithPriceBaseOptions{
    public Label;
    @StoreDataType(FBRowOptions)
    public Rows:FBRowOptions[];
    public ShowSubTotal:boolean;
    public SubTotalLabel:string;


    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Label='List';
        this.Type=FieldTypeEnum.Repeater;
        this.Rows=[];
        this.IsFieldContainer=true;
        this.ShowSubTotal=false;
        this.SubTotalLabel='Subtotal';
        this.PriceType=PriceTypeEnum.sum_of_fields_in_group
    }


    protected GetValueFromLoader(property:keyof this,value:any):any
    {
        if(property=='Fields')
        {
            let fields=[];
            for(let field of value)
               fields.push(FieldFactory.GetFieldOptions(value.Type).Merge(value));

            return fields;
        }

        return null;

    }


}

